// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.etsN81eQB0HEL5rc4wyW {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.bALbfbJcE00HIUhsqU7U {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #f5f5f5;
  padding: 16px;
  border-radius: 4px;
  color: #000;
  width: 100%;
}

._dfBccBWMWi5mE5ggb1w {
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  color: #000;
  font-family: inherit;
}

.pLHcwOXnr9ZrbpwcVhVN {
  font-size: 20px;
  line-height: 28px;
  letter-spacing: -0.8px;
  font-weight: 500;
  color: #000;
  font-family: inherit;
}

.qMXhV5R1MKDs8HfF26Ol {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  color: #000;
  font-family: inherit;
}

._3jHoLtV9PXCGMlGW1_2I {
  color: #707070;
  font-weight: 500;
  font-family: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/modules/retailMedia/components/CampaignForm/elements/BudgetPacingNotice/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB","sourcesContent":[".root {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.box {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background: #f5f5f5;\n  padding: 16px;\n  border-radius: 4px;\n  color: #000;\n  width: 100%;\n}\n\n.title {\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 500;\n  color: #000;\n  font-family: inherit;\n}\n\n.value {\n  font-size: 20px;\n  line-height: 28px;\n  letter-spacing: -0.8px;\n  font-weight: 500;\n  color: #000;\n  font-family: inherit;\n}\n\n.formulaRow {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px;\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 500;\n  color: #000;\n  font-family: inherit;\n}\n\n.muted {\n  color: #707070;\n  font-weight: 500;\n  font-family: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `etsN81eQB0HEL5rc4wyW`,
	"box": `bALbfbJcE00HIUhsqU7U`,
	"title": `_dfBccBWMWi5mE5ggb1w`,
	"value": `pLHcwOXnr9ZrbpwcVhVN`,
	"formulaRow": `qMXhV5R1MKDs8HfF26Ol`,
	"muted": `_3jHoLtV9PXCGMlGW1_2I`
};
export default ___CSS_LOADER_EXPORT___;
